import { FreeQrCodeGeneratorPage as FreeQrCodeGeneratorPageComponent } from '../components/pages/FreeQrCodeGeneratorPage/FreeQrCodeGeneratorPage'
import { FreeQrCodeGeneratorPageJsonLd } from '../components/pages/FreeQrCodeGeneratorPage/FreeQrCodeGeneratorPage.constants'
import { InferGetServerSidePropsType, NextPage } from 'next'
import { getFreeQrCodeGeneratorPageServerSideProps } from '../components/pages/FreeQrCodeGeneratorPage/getFreeQrCodeGeneratorPageServerSideProps'
import Head from 'next/head'

export const getServerSideProps = getFreeQrCodeGeneratorPageServerSideProps

const FreeQrCodeGeneratorPage: NextPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = props => {
  return (
    <>
      <Head>
        <script
          id="locg-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(FreeQrCodeGeneratorPageJsonLd) }}
        />
      </Head>
      <FreeQrCodeGeneratorPageComponent {...props} />
    </>
  )
}

export default FreeQrCodeGeneratorPage
